import React, { useEffect, useState } from 'react';
import Select from '@material-ui/core/Select';
import { useSelector } from 'react-redux';
import { InputLabel, MenuItem } from '@material-ui/core';

function TableFilterBooleanIsNullField(props) {
	const filterList = useSelector(rootState => rootState[props.config.key].tableBrowserFilter.filterList);
	const [value, setValue] = useState('');

	useEffect(() => {
		const index = filterList.findIndex(el => el.propertyName === props.filterConfig.propertyName);
		if (index > -1) {
			setValue(filterList[index].value != null ? filterList[index].value.toString() : '');
		} else {
			setValue('');
		}
	}, [filterList]);

	useEffect(() => {
		const newValue = value.length > 0 ? value === 'true' : null;
		if (newValue !== null) {
			const filterValue = {
				propertyName: props.filterConfig.propertyName,
				type: props.filterConfig.type,
				value: newValue
			};
			props.onFilterChanged(filterValue);
		} else {
			props.onFilterRemoved(props.filterConfig.propertyName);
		}
	}, [value]);

	return (
		<div>
			<InputLabel className="mt-16 w-full">{props.filterConfig.text}</InputLabel>
			<Select value={value} onChange={e => setValue(e.target.value)} className="mt-16 w-full">
				<MenuItem value="Mind" />
				<MenuItem value="true">Igen</MenuItem>
				<MenuItem value="false">Nem</MenuItem>
			</Select>
		</div>
	);
}

export default TableFilterBooleanIsNullField;
